"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fullscreenChange;
function fullscreenChange(type, callback) {
  var vendors = ["fullscreenchange", "mozfullscreenchange", "MSFullscreenChange", "webkitfullscreenchange"];
  vendors.forEach(function (vendor) {
    return document[type + "EventListener"](vendor, callback);
  });
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-media-player/lib/utils/fullscreen-change.js
// module id = 291
// module chunks = 0